import React, { useEffect, useRef, useState } from 'react';
import { Drawer } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import parse from 'html-react-parser';
import benefits from './benefits.json';
import terms from './terms.json';
import MembershipOverview from './MembershipOverview';
import './style.scss';

const pageTitle = '雅星会-会员礼遇';

export default function DiscoverASRBenefits() {
  const pageRef = useRef(null);
  const sectionRefs = useRef({});
  const [detail, setDetail] = useState(null);
  const [footerBefore, footerAfter] = benefits.footer.split('条款和条件');
  const showAllTerms = () => setDetail({ title: '雅星会条款和条件', all: true });

  useEffect(() => {
    document.title = pageTitle;
    // Keep other routes' global container rules out of this mobile comparison table.
    const host = pageRef.current.closest('.container');
    if (!host) return undefined;
    host.classList.add('asr-benefits-host');
    return () => host.classList.remove('asr-benefits-host');
  }, []);

  return (
    <main ref={pageRef}>
 
      <h1 className="hotel-member-title">
        <img className="hotel-member-logo asr-logo" src="https://staticfile.badazhou.com/20260922/7fc5b8db2079a97f70a304d50d6d20a1.png" alt="" />
        <span>{pageTitle}</span>
      </h1>

      <div className="asr-benefits">
      <MembershipOverview />
      <section className="asr-member-benefit" aria-label="各项福利一目了然">
        <div className="asr-benefits__wrap">
          <div className="benefit-listing" role="table" aria-label="雅星会会员权益对照表">
            <div className="benefit-thead" role="row">
              <div className="benefit-title" role="columnheader">{benefits.title}</div>
              {benefits.tiers.map((tier) => (
                <div className="benefit-tier" role="columnheader" key={tier.label} style={{ color: tier.color }}>
                  {tier.label}
                </div>
              ))}
            </div>
            {benefits.items.map((item) => (
              <div className="benefit-item" role="row" key={item.id}>
                <div className="benefit-title" role="rowheader">
                  {item.detail ? (
                    <button
                      type="button"
                      className="benefit-detail-link"
                      aria-label={item.title}
                      aria-haspopup="dialog"
                      onClick={() => setDetail({ title: item.title, ...terms.details[item.detail] })}
                    >
                      {parse(item.html)}
                    </button>
                  ) : <div>{parse(item.html)}</div>}
                </div>
                {item.cells.map((cell, index) => (
                  <div className="benefit-tier" role="cell" key={benefits.tiers[index].label} style={{ color: cell.color }}>
                    {cell.text}
                  </div>
                ))}
              </div>
            ))}
          </div>
          <div className="term-condition">
            <p>{footerBefore}<button type="button" onClick={showAllTerms}>条款和条件</button>{footerAfter}</p>
            <p aria-hidden="true">&nbsp;</p>
          </div>
        </div>
      </section>
      <Drawer
        open={detail !== null}
        placement="right"
        width="100%"
        rootClassName="asr-benefit-drawer"
        closable={false}
        onClose={() => setDetail(null)}
        title={
          <div className="asr-detail-header">
            <button type="button" aria-label="返回会员礼遇" title="返回会员礼遇" onClick={() => setDetail(null)}>
              <ArrowLeftOutlined aria-hidden="true" />
            </button>
            <h2>{detail?.title}</h2>
          </div>
        }
      >
        {detail && (
          <article className="asr-terms-content" lang={detail.language || 'zh-CN'}>
            {detail.all ? (
              <>
                {parse(terms.intro)}
                <ol className="asr-terms-index">
                  {terms.sections.map((section) => (
                    <li key={section.id}>
                      <button type="button" onClick={() => sectionRefs.current[section.id]?.scrollIntoView({ block: 'start' })}>
                        {section.title.replace(/^\d+\.\s*/, '')}
                      </button>
                    </li>
                  ))}
                </ol>
                {terms.sections.map((section) => (
                  <section key={section.id} ref={(node) => { sectionRefs.current[section.id] = node; }}>
                    {parse(section.html)}
                  </section>
                ))}
              </>
            ) : parse(detail.html)}
          </article>
        )}
      </Drawer>
      </div>
    </main>
  );
}
